import { memoize } from '../cache/memoize';

export const getIntlRelativeTimeFormat = memoize(function getIntlRelativeTimeFormat(...args: ConstructorParameters<typeof Intl.RelativeTimeFormat>) {
  return new Intl.RelativeTimeFormat(...args);
});
